import styled from '@emotion/styled';

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 4.8rem;
	max-width: 44rem;
	width: 100%;
`;
export const Title = styled.h2`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: 600;
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const MenuBoxList = styled.div`
	display: flex;
	width: 100%;
`;
export const MenuBox = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 0.8rem;
	padding: 2rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: 600;
	line-height: 120%;
	letter-spacing: -0.6px;
	color: #dee2e6;
	background-color: #f1f3f5;
	.sub_title {
		color: #495057;
	}
	&.active {
		background-color: ${(props) => props.theme.colors.primary400};
		.sub_title {
			color: #fff;
		}
	}
`;
export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;
export const SelectBox = styled.div`
	height: 4.4rem;
`;
export const FieldCheckBox = styled.label`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: 400;
	line-height: 140%;
	letter-spacing: -0.6px;
	justify-content: flex-end;
`;
export const NextButton = styled.button`
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: none;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
	}
`;
export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.4rem;
	width: 100%;
	height: 4.4rem;
	div {
		flex: 1;
	}
	input {
		flex: 1;
	}
`;
export const GenderBox = styled.div`
	display: flex;
	gap: 4rem;
`;
export const GenderRadio = styled.div`
	display: flex;
	gap: 0.4rem;
	input[type='radio'] {
		-webkit-appearance: none; // 웹킷 브라우저에서 기본 스타일 제거
		-moz-appearance: none; // 모질라 브라우저에서 기본 스타일 제거
		appearance: none; // 기본 브라우저에서 기본 스타일 제거
		width: 20px;
		height: 20px;
		border: 1px solid #ced4da; // 체크되지 않았을 때의 테두리 색상
		border-radius: 50%;
		outline: none; // focus 시에 나타나는 기본 스타일 제거
		cursor: pointer;
	}
	// 체크 시 버튼 모양 스타일
	input[type='radio']:checked {
		background-color: #fff; // 체크 시 내부 원 색상
		border: 6px solid ${(props) => props.theme.colors.primary400}; // 라인이 아닌, 라인과 원 사이 색상
	}
	label {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.4rem;
		cursor: pointer;
	}
`;
export const AddressInput = styled.input`
	width: 100%;
	&:read-only {
		background-color: #e9ecef;
		border: 1px solid #adb5bd;
	}
`;
export const FindButton = styled.button`
	background-color: #212529;
	color: #fff;
	padding: 0 1.2rem;
	white-space: nowrap;
	min-width: 8rem;
	border: none;
	height: 100%;
	flex-shrink: 0; /* 버튼이 줄어들지 않도록 설정 */
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
	}
`;
export const AddressBox = styled.div`
	display: flex;
	gap: 0.4rem;
	height: 4.4rem;
`;
export const AddressContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
`;
export const TabBox = styled.div`
	display: flex;
	width: 100%;
	height: 4.4rem;
	background-color: #fff;
	color: #868e96;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	.tab {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		height: 100%;
		border: 1.4px solid #adb5bd;
		&.active {
			border: 1px solid ${(props) => props.theme.colors.primary400};
			color: ${(props) => props.theme.colors.primary400};
		}
	}
`;
export const Danger = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	color: ${(props) => props.theme.colors.red600};
`;
export const PasswordInput = styled.input`
	height: 4.4rem;
	padding: 0 1.2rem;
	border: 1px solid #adb5bd;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #212121;
	width: 100%;
	&:focus {
		outline-color: ${(props) => props.theme.colors.primary400};
	}
	&::placeholder {
		color: #adb5bd;
	}
	&:read-only {
		background-color: #e9ecef;
		border: 1px solid #adb5bd;
	}
`;
export const SecessionButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	color: #495057;
	height: 4rem;
	padding: 0 1.2rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	border: none;
	width: 100%;
	cursor: pointer;
	width: fit-content;
`;
export const ButtonBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	.button_wrap {
		display: flex;
		justify-content: center;
		width: 100%;
	}
`;
